import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { styledMedia } from '@pkg/primitives';

import { tokens } from './EditablePrice.tokens';

export const StyledEditablePrice = styled.div`
    display: flex;
    justify-content: end;
    gap: ${tokens.gap}px;
    flex: 1 1 auto;
`;

export const FormGroupControl = styled.div`
    &:first-child {
        flex: 0 0 auto;
    }

    &:last-child {
        flex: 1 1 auto;
        min-width: ${tokens.control.lastChild.minWidth}px;
    }
`;

export const InputPrefix = styled.div`
    ${styledMedia.iconWrapper};
    margin-left: ${tokens.gap}px;
    width: ${tokens.prefix.size}px;
    height: ${tokens.prefix.size}px;
    color: rgba(255, 255, 255, 0.5);
`;

export const InputSuffix = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    margin-right: ${tokens.suffix.spaceAfter}px;
`;
